import { QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from 'react-router-dom'
import { TooltipProvider } from '@/components/ui/tooltip'
import { AuthProvider } from '@/auth/AuthProvider'
import { queryClient } from '@/lib/queryClient'
import { router } from '@/router'
import { Toaster } from '@/components/Toaster'
import { LimitReachedDialog } from '@/components/LimitReachedDialog'
import { StaleVersionToast } from '@/components/StaleVersionToast'

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <TooltipProvider delayDuration={150}>
          <RouterProvider router={router} />
          <Toaster />
          <LimitReachedDialog />
          <StaleVersionToast />
        </TooltipProvider>
      </AuthProvider>
    </QueryClientProvider>
  )
}
